// extracted by mini-css-extract-plugin
module.exports = {"secondaryNav":"style__secondaryNav__JcEvF"};